var render = function () {
var _obj, _obj$1, _obj$2, _obj$3;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['flex', 'absolute', 'bottom-0', 'left-0']},[_c('div',{class:[
      'flex',
      'items-center',
      ( _obj = {}, _obj[_vm.lightMainBgColorClass] = _vm.isBrowserDecidingDarkMode || _vm.isForcedLight, _obj['text-dark-text-100'] =  _vm.isBrowserDecidingDarkMode || _vm.isForcedLight, _obj[_vm.darkBrowserMainBgColorClass] = _vm.isBrowserDecidingDarkMode, _obj['dark:text-light-text-100'] =  _vm.isBrowserDecidingDarkMode, _obj[_vm.darkMainBgColorClass] = _vm.isForcedDark, _obj['text-light-text-100'] =  _vm.isForcedDark, _obj ),
      'text-12',
      'h-6',
      'pl-2',
      'flex-shrink',
      'min-w-0' ]},[_vm._t("default")],2),_vm._v(" "),_c('svg',{staticClass:"transform scale-100 flex-shrink-0",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{class:[
        'fill-current',
        ( _obj$1 = {}, _obj$1[_vm.lightSlopeColorClass] = _vm.isBrowserDecidingDarkMode || _vm.isForcedLight, _obj$1 ),
        ( _obj$2 = {}, _obj$2[_vm.darkBrowserSlopeColorClass] = _vm.isBrowserDecidingDarkMode, _obj$2 ),
        ( _obj$3 = {}, _obj$3[_vm.darkSlopeColorClass] = _vm.isForcedDark, _obj$3 ) ],attrs:{"d":"M0 0C0 0 8.5 0 12 12C15.5 24 24 24 24 24H0V0Z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }